export const loadBuffer = async (): Promise<ArrayBuffer> => {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.addEventListener('change', () => {
            if(input.files && input.files.length > 0) {
                const
                    file = input.files[0],
                    reader = new FileReader();
                reader.addEventListener('load', () => {
                    resolve(reader.result as ArrayBuffer);
                });
                reader.addEventListener('error', reject);
                reader.addEventListener('abort', reject);
                reader.readAsArrayBuffer(file);
            }
        });
        input.click();
    });
};
export default loadBuffer;
